export var Errors;
(function(Errors2) {
  Errors2["CartNotFound"] = "cart-not-found";
  Errors2["CartItemNotFound"] = "cart-item-not-found";
  Errors2["MaxAmountOfArticleInCart"] = "max-amount-of-article-im-cart";
  Errors2["ValidationError"] = "validation-error";
  Errors2["ArticleNotFound"] = "article-not-found";
  Errors2["ArticlePriceNotFound"] = "acticle-price-not-found";
  Errors2["FileTypeNotValid"] = "file-type-not-valid";
  Errors2["ArticleCorruptDeliveryTypeMissing"] = "article-corrupt-delivery-type-missing";
  Errors2["ArticleCorruptDeliveryTypeCorrupt"] = "article-corrupt-delivery-type-corrupt";
  Errors2["ArticlePackageTypeMissing"] = "article-package-type-missing";
  Errors2["PageNotFoundForArticle"] = "page-not-found-for-article";
  Errors2["PageNotFound"] = "page-not-found";
  Errors2["VariableProductMissing"] = "variable-product-missing";
  Errors2["ZipCodeIsOnGermanIsland"] = "zipcode-is-german-island";
})(Errors || (Errors = {}));
